import axios from 'axios';

export function getAdvertiserPlatformAgreement(amountUsd, options = {}) {
    const params = {};
    if (amountUsd != null && amountUsd !== '') {
        params.amountUsd = amountUsd;
    }
    const screenCount = Math.floor(Number(options.screenCount) || 0);
    if (screenCount > 0) {
        params.screenCount = screenCount;
    }
    const ids = (options.selectedScreenIds || [])
        .map((id) => parseInt(id, 10))
        .filter((id) => Number.isFinite(id) && id > 0);
    if (ids.length > 0) {
        params.screenIds = ids.join(',');
    }
    const fleetSize = Math.floor(Number(options.fleetSize) || 0);
    if (fleetSize > 0) {
        params.fleetSize = fleetSize;
    }
    return axios.get(`${process.env.REACT_APP_API_URL}/legal/advertiser-platform-agreement`, { params });
}
